import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { AdminOrderItemComponentGroup } from '../../models/admin-order-item-component-group';
import { AdminOrderComponentsListComponent } from '../admin-order-components-list/admin-order-components-list.component';

@Component({
  selector: 'app-admin-order-item-component-groups',
  imports: [AdminOrderComponentsListComponent],
  templateUrl: './admin-order-item-component-groups.component.html',
  styleUrl: './admin-order-item-component-groups.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminOrderItemComponentGroupsComponent {
  public readonly groups = input.required<AdminOrderItemComponentGroup[]>();
}
